export const timelineHorizontalScroll = (): void => {
  let localPastPreviousScrollLeft = -1
  let localPreviousScrollLeft = 0

  setInterval(() => {
    localPastPreviousScrollLeft = -1
  }, 300)

  const allTimelineBlocks = document.querySelectorAll('.js-timeline') as unknown as HTMLElement[]

  const reactToScroll = (event: WheelEvent, block: HTMLElement): void => {
    if (event.deltaY < 0) {
      if (block.scrollLeft + event.deltaY > 0) {
        event.preventDefault()
        block.scrollLeft += event.deltaY
        localPastPreviousScrollLeft = localPreviousScrollLeft
        localPreviousScrollLeft = block.scrollLeft
      }
      else {
        block.scrollLeft = 0
      }
      if (block.scrollLeft < 0) {
        block.scrollLeft = 0
        localPastPreviousScrollLeft = localPreviousScrollLeft
        localPreviousScrollLeft = block.scrollLeft
      }
    }

    else if (event.deltaY > 0) {
      if (block.scrollLeft + event.deltaY > localPreviousScrollLeft && localPastPreviousScrollLeft !== localPreviousScrollLeft) {
        event.preventDefault()
        block.scrollLeft += event.deltaY
        localPastPreviousScrollLeft = localPreviousScrollLeft
        localPreviousScrollLeft = block.scrollLeft
      }
    }
  }

  allTimelineBlocks.forEach((timelineBlock: HTMLElement) => {
    timelineBlock.addEventListener('wheel', (e: WheelEvent): void => {
      reactToScroll(e, timelineBlock)
    })
  })
}
